import React from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import CircularProgress from '../../../common/ui/CircularProgress'
import { ColorBoxContent } from '../../../common/ui/colorBox'
import { formatRelativeDate } from '../../../helpers/date'

function DataVoiceSms({ bundleUsage, bundle, convertData, convertVoice }) {
  return (
    <ColorBoxContent>
      {/* Coming Soon Removed, Mock Data Shown */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '30%'
          }}
        >
          {/* DATA CHART */}
          <Box>
            <Typography variant='h5'>Data</Typography>
            <CircularProgress
              value={(bundleUsage.remainingData / bundle.data) * 100}
              quantity={convertData(bundleUsage.remainingData)}
              unit='GB'
              color='#C51398'
              fieldApplicable={bundle.dataApplicable}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '30%'
          }}
        >
          {/* VOICE CHART */}
          <Box>
            <Typography variant='h5'>Voice</Typography>
            <CircularProgress
              value={(bundleUsage.remainingVoice / bundle.voice) * 100}
              quantity={convertVoice(bundleUsage.remainingVoice)}
              unit='min'
              color='#A4AAFF'
              fieldApplicable={bundle.voiceApplicable}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '30%'
          }}
        >
          {/* SMS CHART */}
          <Box
            sx={{
              justifyContent: 'flex-end',
              alignItems: 'flex-start'
            }}
          >
            <Typography variant='h5'>SMS</Typography>
            <CircularProgress
              value={(bundleUsage?.remainingSms / bundle?.sms) * 100}
              quantity={bundleUsage?.remainingSms}
              unit='SMS'
              color='#78E0E7'
              fieldApplicable={bundle.smsApplicable}
            />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex'
        }}
        style={{ marginTop: '20px' }}
      >
        <Typography sx={{ color: 'gray' }}>
          <em>Last updated at {formatRelativeDate(bundleUsage.updatedAt)}</em>
        </Typography>
      </Box>
    </ColorBoxContent>
  )
}

DataVoiceSms.propTypes = {
  bundleUsage: PropTypes.object,
  bundle: PropTypes.object,
  convertData: PropTypes.func,
  convertVoice: PropTypes.func
}

export default DataVoiceSms
